export default __webpack_public_path__ + "static/media/select.b7a09cfb.png";